export default {
  path: '/apply_shop',
  meta: {
    title: '商家入驻',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/apply_shop`),
}



// WEBPACK FOOTER //
// ./src/views/Join/router.js